// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"70fa552e","453":"75dabde4"}[chunkId] + ".chunk.js";
};